import type { LocalStorageContextProps } from '../Contexts/LocalStorageContext';
import type { ModeContextProps } from '../Contexts/ModeContext';
import Mode from '../Enums/Mode';

export function handleLogout(modeContext: ModeContextProps, localStorageContext: LocalStorageContextProps, changeMode: boolean): void {
    
    if (changeMode) {
        modeContext.setMode(Mode.RELOGIN);
        localStorageContext.localStorageService.setMode(Mode.RELOGIN);
    }
}